import * as React from "react";
import Button from "../Button/Button";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import Icon from "../Icon/Icon";
import styles from "./DataTable.module.scss";
import clsx from "clsx";

export const DataTableBaseMenuList = React.forwardRef<HTMLUListElement, React.HTMLAttributes<HTMLUListElement>>(
  ({ children, className, ...props }, ref) => (
    <DropdownMenu.Content
      ref={ref}
      className={clsx(styles.menuList, className)}
    >
        {children}
    </DropdownMenu.Content>
  ),
);
DataTableBaseMenuList.displayName = "DataTableBaseMenuList";

export const DataTableBaseMenuItem = React.forwardRef<HTMLDivElement, any>(
  ({ children, className, disabled, iconStart, onClick, ...props }, ref) => (
    <DropdownMenu.Item
      ref={ref}
      className={className}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {iconStart ? <DropdownMenu.Item.Icon>{iconStart}</DropdownMenu.Item.Icon> : null}
      <DropdownMenu.Item.Label>{children}</DropdownMenu.Item.Label>
    </DropdownMenu.Item>
  ),
);
DataTableBaseMenuItem.displayName = "DataTableBaseMenuItem";

export const DataTableBaseDivider = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <DropdownMenu.Separator
      ref={ref}
      className={className}
      {...props as any}
    />
  ),
);
DataTableBaseDivider.displayName = "DataTableBaseDivider";

export const DataTableBaseIconButton = React.forwardRef<HTMLButtonElement, any>(
  ({ children, className, size: _size, title, "aria-label": ariaLabel, ...props }, ref) => (
    <Button
      ref={ref}
      icon
      size="sm"
      variant="ghost"
      label={ariaLabel ?? title ?? "Menu"}
      tooltip={false}
      className={className}
      {...props}
    >
      {children}
    </Button>
  ),
);
DataTableBaseIconButton.displayName = "DataTableBaseIconButton";

export const DataTableColumnMenuIcon = () => <Icon name="show-more" />;
export const DataTableSortAscendingIcon = () => <Icon name="move-up" />;
export const DataTableSortDescendingIcon = () => <Icon name="move-down" />;
export const DataTableFilterIcon = () => <Icon name="filter" />;
export const DataTableHideColumnIcon = () => <Icon name="hide" />;
export const DataTableManageColumnsIcon = () => <Icon name="table-settings" />;
